"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _paulCorePackage = require("paul-core-package");
var _reactRedux = require("react-redux");
var _useGetValue = require("../../hooks/useGetValue");
var _ValueStatusText = _interopRequireDefault(require("./ValueStatusText"));
var _CustomCircle = _interopRequireDefault(require("./CustomCircle"));
var _constants = require("../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const OtherValuesCircleWrap = _ref => {
  let {
    thingPDIDDevice,
    hover = false
  } = _ref;
  const powerDisplayNameId = (0, _useGetValue.useGetValueIdsByRegDeviceId)({
    thingPDIDDevice,
    regular: _paulCorePackage.constants.regularsByDisplayNameId.powerRegex
  });
  const flowDisplayNameId = (0, _useGetValue.useGetValueIdsByRegDeviceId)({
    thingPDIDDevice,
    regular: _paulCorePackage.constants.regularsByDisplayNameId.flowValveRegex
  });
  const tI = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsInterfaceUILocalizations);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "flex-column justify-content-end h-100"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "flex-center",
    sx: {
      gap: '0px 25px'
    }
  }, /*#__PURE__*/_react.default.createElement(_CustomCircle.default, {
    thingPDIDDevice: thingPDIDDevice,
    displayNameId: powerDisplayNameId,
    hover: hover,
    hasPositionValue: true,
    title: tI[69] /* 'Power' */,
    circleParams: {
      type: _constants.circleType.power,
      isCorrectValue: true
    },
    isCorrectValue: true
  }), /*#__PURE__*/_react.default.createElement(_CustomCircle.default, {
    thingPDIDDevice: thingPDIDDevice,
    displayNameId: flowDisplayNameId,
    hover: hover,
    hasPositionValue: true,
    title: tI[70] /* 'Flow' */,
    circleParams: {
      type: _constants.circleType.flow,
      isCorrectValue: true
    },
    isCorrectValue: true
  })), /*#__PURE__*/_react.default.createElement(_ValueStatusText.default, {
    thingPDIDDevice: thingPDIDDevice,
    regular: _paulCorePackage.constants.paramsByDisplayNameId.pMax,
    tKey: 78
  }));
};
var _default = exports.default = OtherValuesCircleWrap;